import { render } from "./orderusedrecordmodel.vue?vue&type=template&id=cb4d986a"
import script from "./orderusedrecordmodel.vue?vue&type=script&lang=ts"
export * from "./orderusedrecordmodel.vue?vue&type=script&lang=ts"
script.render = render

export default script